import React from "react";
import { useNavigate } from "react-router-dom";
import { useEvents } from "../../contexts/EventsContext";

export default function Events() {
  const navigate = useNavigate();
  const { events, loading } = useEvents();

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-xl text-gray-600">Loading events...</p>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 py-12 sm:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Header Section */}
        <div className="max-w-2xl lg:mx-0">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            Upcoming Events
          </h2>
          <p className="mt-2 text-lg text-gray-600">
            Stay updated with the latest events and activities we have lined up for you.
          </p>
        </div>

        {/* Events Grid */}
        <div className="mx-auto mt-8 grid max-w-2xl grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:max-w-none">
          {events.map((event) => (
            <article
              key={event.id}
              className="flex flex-col items-start justify-between rounded-lg shadow-md bg-white overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
              onClick={() => navigate(`/events/${event.id}`)}
            >
              {/* Event Image */}
              <img
                className="w-full h-48 object-cover"
                src={event.imageUrl}
                alt={event.title}
              />

              <div className="p-6 space-y-3">
                {/* Event Date */}
                <time dateTime={event.date} className="text-sm text-gray-500">
                  {event.date}
                </time>

                {/* Event Title */}
                <h3 className="text-xl font-semibold text-gray-900 hover:text-indigo-600 transition-colors">
                  {event.title}
                </h3>

                {/* Event Description */}
                <p className="text-sm text-gray-600 line-clamp-3">
                  {event.description}
                </p>
              </div>
            </article>
          ))}
        </div>

        {/* No Events Message */}
        {events.length === 0 && (
          <p className="text-center text-gray-500 mt-8 text-lg">No upcoming events found.</p>
        )}
      </div>
    </div>
  );
}
